<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="24">
        <div class="element-select">
          <el-select v-model="value" @change="adminModulePointPie" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div id="charts-box"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { API__code, API_Admin } from "../../../api/index.js";
export default {
  props:['userid'],
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      value: "1",
      loading:false,
      options: [
        {
          value: "1",
          label: "最近一个月",
        },
        {
          value: "3",
          label: "最近三个月",
        },
        {
          value: "6",
          label: "最近半年",
        },
        {
          value: "12",
          label: "最近一年",
        },
      ],
      chartPie:[],
      legend:[],
      chartsXAxisTwo:[],
      chartsDataTwo:[],
      token:'',
      checkCode:''
    };
  },
  created() {
    this.getCookie()
  },
  mounted() {
    this.getData();
  },
  methods: {
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } 
            }
        }
    },
    getData() {
      this.adminModulePointPie();
    },
    adminModulePointPie(val) {
      var param = {
        count: this.value,
        userid:this.userid,
        token:this.token,
        checkCode:this.checkCode,
      };
      this.loading = true
      API_Admin.pointByPerson(param).then((res) => {
        if(res.data.code == 200){
            this.chartsXAxisTwo = res.data.data.x;
            this.chartsDataTwo = res.data.data.y;
            this.initCharts();
            this.loading = false;
            }
      });
    },
    initCharts() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: [
          {
            text: "积分统计",
            top: "top",
            left: "left",
            textStyle: {
              color: "#596471",
              fontSize: 18,
              fontWeight: 400,
              fontFamily: 'SourceHanSansCN'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          position: function (point,params,dom,rect,size) {
            if((size.viewSize[0]/2)>=point[0]){
             //其中point为当前鼠标的位置
             return [point[0],'10%'];
            }else{
                //其中point为当前鼠标的位置
                return [point[0]-80,'10%'];
            }
          },
          formatter: (params) => {
            return `${params[0].name}<br/>${params[0].seriesName}: ${(
              params[0].value + ""
            ).replace(/\B(?=(?:\d{3})+\b)/g, ",")}分`;
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
            rotate: 20,
          },
          splitArea: {},
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        series: [
          {
            name: "积分统计",
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#EF5350",
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FFB87D",
                  },
                  {
                    offset: 1,
                    color: "#ED7D76",
                  },
                ]),
              },
            },
            data: this.chartsDataTwo,
            lineStyle: {
              normal: {
                color: "#EF5350",
              },
            },
          },
        ],
      });
      charts.hideLoading(); //隐藏等待框
      this.loading = false;
      window.addEventListener("resize", () => {
        charts.resize();
      }); //自适应图表大小
    },
  },
};
</script>

<style scoped lang="scss">
#charts-box {
  width: 100%;
  height: 336px;
  background-color: white;
  border-radius: 2px;
}

.element-select {
  float: right;
  position: relative;
  z-index: 888;
}
</style>



// WEBPACK FOOTER //
// charts.vue?eca373a2